import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { Separator } from "../ui/separator";
import { SetRow } from "./SetRow";
import { SetCard } from "./SetCard";

interface SetItem { id: string; number: number; reps: number; minutes: number; seconds: number; distance: number | ""; energy_zone: string; description?: string; }

interface SetListProps {
  sets: SetItem[];
  energyZones: string[];
  onUpdate: (id: string, field: keyof SetItem, value: any) => void;
  onDelete: (set: SetItem) => void;
  calculateTotalTime: () => string;
  calculateTotalDistance: () => number;
}

/**
 * Component for displaying the list of sets with desktop and mobile views
 */
export function SetList({
  sets,
  energyZones,
  onUpdate,
  onDelete,
  calculateTotalTime,
  calculateTotalDistance,
}: SetListProps) {
  if (sets.length === 0) {
    return (
      <Card className="p-10 text-center border-dashed border-[0.5px] border-muted">
        <h2 className="text-xl font-semibold mb-2">No sets available</h2>
        <p className="text-muted-foreground">
          This practice has no laps yet. You can start by adding sets using
          the Quick Actions on the right.
        </p>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Current Sets</CardTitle>
      </CardHeader>
      <CardContent>
        {/* Desktop View */}
        <div className="hidden md:block">
          <div className="grid grid-cols-12 gap-4 px-4 py-2 bg-muted/50 rounded-lg mb-2">
                <div className="col-span-2 text-sm font-medium"># of Rep</div>
                <div className="col-span-2 text-sm font-medium">Distance (m)</div>
                <div className="col-span-2 text-sm font-medium">Interval</div>
                <div className="col-span-3 text-sm font-medium">Energy Zone</div>
                <div className="col-span-2 text-sm font-medium">Description</div>
                <div className="col-span-1 text-sm font-medium">Actions</div>
              </div>

          <div className="space-y-2">
            {sets.map((set) => (
              <SetRow
                key={set.id}
                set={set}
                energyZones={energyZones}
                onUpdate={onUpdate}
                onDelete={onDelete}
              />
            ))}
          </div>
        </div>

        {/* Mobile View */}
        <div className="md:hidden space-y-4">
          {sets.map((set) => (
            <SetCard
              key={set.id}
              set={set}
              energyZones={energyZones}
              onUpdate={onUpdate}
              onDelete={onDelete}
            />
          ))}
        </div>


        {/* Totals */}
        {sets.length > 0 && (
          <>
            <Separator />
            <div className="space-y-2 mt-2">
              <div className="flex justify-between items-center px-4 py-2 bg-primary/5 rounded-lg">
                <span className="font-medium">Total Training Time:</span>
                <Badge variant="default" className="px-4 py-1 text-base">
                  {calculateTotalTime()}
                </Badge>
              </div>

              <div className="flex justify-between items-center px-4 py-2 bg-primary/5 rounded-lg">
                <span className="font-medium">Total Distance:</span>
                <Badge variant="secondary" className="px-4 py-1 text-base">
                  {calculateTotalDistance()} m
                </Badge>
              </div>
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
}

